import { Navigate, useLocation } from "react-router";
import dayjs from "dayjs";
import utcPlugin from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
dayjs.extend(utcPlugin);
export default function OutOfHours() {
  const { state } = useLocation();

  if (!state?.redirected) {
    return <Navigate to="/" />;
  }

  return (
    <div className="card mx-auto w-full max-w-lg px-4 py-8 text-center">
      <h1 className="text-red mb-4 font-bold">Sorry</h1>
      <h2 className="text-red mx-auto mb-6 max-w-xs text-center font-bold">
        {/* this promotion is only open between{" "}
        {dayjs.utc(`${state?.data?.startHour}`, "H").format("ha")} and{" "}
        {dayjs.utc(`${state?.data?.endHour}`, "H").format("ha")}. */}
        This promotion is only open during restaurant opening hours.
      </h2>
      <p className="text-red mx-auto max-w-xs text-center">
        please check back again during these hours.
      </p>
    </div>
  );
}
